module.exports = __webpack_public_path__ + "static/media/waves-background.958fc5c9.jpg";